export enum VIEW_KEYS {
    RULES = 'RULES',
    EXTENSIONS = 'EXTENSIONS',
};

export enum VIEW_POLICY_STATE {
    PARENT =  'PARENT',
    NODE = 'NODE',
};
